import React from 'react'

const AppFooter = () => {
  return (
    <div className='copyright border-top'>Copyright @ A Ride Company 2024 – 2025. All Rights Reserved</div>
  )
}

export default AppFooter